import * as React from "react";
import { Layout, LayoutProps } from "react-admin";
import { GybAppBar } from "../views/components/gyb-appbar";
import NestedMenu from "../views/components/nested-menu";
import { ListUpdateNotification } from "../views/components/list-update-notification";

/**
 * 全局 Layout：自定义 AppBar/菜单，并挂载列表更新轮询通知。
 */
export const GybLayout: React.FC<LayoutProps> = (props) => (
  <>
    <Layout {...props} appBar={GybAppBar} menu={NestedMenu} />
    <ListUpdateNotification />
  </>
);
